import { Redirect } from 'expo-router'
import { useEffect } from 'react'

import { useAppStore } from '@/store/useAppStore'
import trpc from '@/utils/trpc'

const RootIndex = () => {
  const auth = useAppStore.use.auth()
  const orgId = useAppStore.use.currentOrganization().organization?.id
  const setCurrentOrganization = useAppStore.use.setCurrentOrganization()

  const needsOrgResolution = auth.isLoggedIn === true && !orgId
  const currentUserQuery = trpc.user.current.useQuery(
    { organizationId: undefined },
    { enabled: needsOrgResolution }
  )

  useEffect(() => {
    if (!currentUserQuery.data?.organizations?.length || orgId) return
    const firstOrg = currentUserQuery.data.organizations[0].organization
    setCurrentOrganization({
      organization: {
        id: firstOrg.id,
        adoptionContract: firstOrg.adoptionContract || null,
        logo: firstOrg.logo || null,
        qrCode: firstOrg.qrCode || null,
        name: firstOrg.name,
      },
    })
  }, [currentUserQuery.data, orgId, setCurrentOrganization])

  if (auth.isLoggedIn === undefined) return null
  if (auth.isLoggedIn === false) return <Redirect href="/login" />
  if (orgId) return <Redirect href={`/organization/${orgId}/dashboard`} />
  if (needsOrgResolution && currentUserQuery.isLoading) return null

  if (currentUserQuery.data?.isFirstRunRequired) {
    return <Redirect href="/getting-started/first-run" />
  }

  return <Redirect href="/getting-started" />
}

export default RootIndex
